import { gql, useMutation } from '@apollo/client';

export const GET_PRODUCTS_COUNT = gql`
query productsCount($active: Boolean) {
    productsCount(active: $active) 
}
`;

export const GET_PRODUCT_BY_ID = gql`
  query GetProductById($id: ID!) {
    product(id: $id) {
      id
      reference
      name
      brand
      group {
        id
        name
      }
      description
      active
      imageUrl
      infos
      priceSegmentations
      
    }
  }
`;

export const GET_PRODUCTS = gql`
  query GetProducts($page: Int, $perPage: Int, $search: String, $advancedFilters: [JSON!]) {
    products(page: $page, perPage: $perPage, search: $search, advancedFilters: $advancedFilters) {
      edges {
        node {
          id
          name
          brand
          price
          createdAt
          description
          internalId
          reference
          group {
            id
            name
          }
          active
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      },
      totalCount

    }
  }
`;

const UPDATE_PRODUCT_STATUS = gql`
  mutation UpdateProductStatus($id: ID!, $active: Boolean!) {
    updateProductStatus(input: { id: $id, active: $active }) {
      product {
        id
        active
      }
      errors
    }
  }
`;

export const useUpdateProductStatus = () => {
  return useMutation(UPDATE_PRODUCT_STATUS);
};

const CREATE_PRODUCT = gql`
  mutation CreatePedidosMoveisProduct(
    $attributes: PedidosMoveisProductAttributes!
  ) {
    createPedidosMoveisProduct(input: { attributes: $attributes }) {
      product {
        id
        reference
        name
        brand
        group {
          id
          name
        }
        description
        imageUrl
      }
      errors
    }
  }
`;

const UPDATE_PRODUCT = gql`
  mutation UpdatePedidosMoveisProduct( $attributes: PedidosMoveisProductAttributes! ) {
    updatePedidosMoveisProduct(input: { attributes: $attributes }) {
      product {
        id
        reference
        name
        brand
        group {
          id
          name
        }
        imageUrl
      }
      errors
    }
  }
`;

export const useCreateProduct = () => {
  return useMutation(CREATE_PRODUCT);
};

export const useUpdateProduct = () => {
  return useMutation(UPDATE_PRODUCT);
};